import {AxiosPromise} from 'axios';
import api from './api';
import apiGraphQL from './apiGraphQL';
import {SessionTypes} from '../enums';
import {DefaultSuccessResponse, PlayerSession} from '../interfaces';

export function getPlayerSessions(params: {
  profileId?: number;
  playerId?: number;
}) {
  const {profileId, playerId} = params;

  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .get('/playersessions', {
          params: {
            profileId,
            playerId,
          },
        })
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getPlayerSessionDetail(id: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .get(`/playersession/${id}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function updatePlayerSession(id: number, params: {timeZone?: string}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .put(`/playersessions/${id}`, params)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function deletePlayerSession(playerSessionId: number) {
  return new Promise<DefaultSuccessResponse>((resolve, reject) => {
    try {
      api
        .delete(`/player-sessions/${playerSessionId}`)
        .then(response => {
          resolve(response?.data);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function reprocessPlayerSession({id}: {id: number}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation ($id: Int!) {
            reprocessPlayerSession(id: $id) {
              success,
            }
          }`,
          variables: {
            id,
          },
        })
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function createLostPlayerSession({
  profileId,
  teamSessionId,
}: {
  profileId: number;
  teamSessionId?: number;
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation CreateLostPlayerSession($input: CreateLostPlayerSessionInput!) {
            createLostPlayerSession(input: $input) {
              id
            }
          }`,
          variables: {
            input: {
              profileId,
              teamSessionId,
            },
          },
        })
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function downloadAllShifts(playerSessionId: number, emailLink: boolean) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation downloadShiftVideos($playerSessionId: Int!, $emailLink: Boolean) {
            downloadShiftVideos(playerSessionId: $playerSessionId, emailLink: $emailLink) {
              downloadProcessing
              downloadLink
            }
          }`,
          variables: {
            playerSessionId,
            emailLink,
          },
        })
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function updateSessionVideoSegmentOffset({
  sessionVideoSegments,
}: {
  sessionVideoSegments: {sessionVideoSegmentId: number; offset: number}[];
}) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation updateSessionVideoSegmentOffset($sessionVideoSegments: [SessionVideoSegmentOffsetPair!]!) {
            updateSessionVideoSegmentOffset(input: {sessionVideoSegments: $sessionVideoSegments}) {
              success
            }
          }`,
          variables: {
            sessionVideoSegments,
          },
        })
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function adminDeletePlayerSession(playerSessionId: number) {
  return new Promise<DefaultSuccessResponse>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation AdminDeletePlayerSession($input: AdminDeletePlayerSessionInput!) {
            adminDeletePlayerSession(input: $input) {
              success
              error
            }
          }`,
          variables: {
            input: {
              playerSessionId,
            },
          },
        })
        .then(response => {
          resolve(response?.data?.data?.adminDeletePlayerSession ?? null);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function adminChangePlayerSessionType(
  playerSessionId: number,
  type: SessionTypes,
) {
  return new Promise<DefaultSuccessResponse>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation AdminChangePlayerSessionType($input: AdminChangePlayerSessionTypeInput!) {
            adminChangePlayerSessionType(input: $input) {
              success
              error
            }
          }`,
          variables: {
            input: {
              playerSessionId,
              type,
            },
          },
        })
        .then(response => {
          resolve(response?.data?.data?.adminChangePlayerSessionType ?? null);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
